import { Controller } from '@hotwired/stimulus';

export default class RadioLinkSwitcherController extends Controller {
  static targets = [
    'radio',
    'link'
  ];

  connect() {
    this.switch();
  }

  switch() {
    const radio = this.radioTargets.find(radio => radio.checked);

    this.linkTarget.href = radio.dataset.href;
  }
}
